import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NativeSoilPrintTableComponent } from './native-soil-print-table/native-soil-print-table.component';

const routes: Routes = [
  {
    path: '',
    component : NativeSoilPrintTableComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NativeSoilPrintRoutingModule { }
